// The platform seam entry point. The shared core imports `{ platform }` from
// here. Which implementation is bound is a BUILD-TIME choice: today it's always
// the extension; the web/PWA build will swap the import (esbuild alias/define)
// so neither shell ships the other's code. See
// 02_ENGINEERING/Platform_Abstraction_Plan.md.
export type { Platform, PlatformStorage, CrossTabIntegration } from "./types.js";
import type { Platform } from "./types.js";
import { extensionPlatform } from "./extension.js";
import { webPlatform } from "./web.js";

// Build-time shell selection. esbuild replaces __PLATFORM__ with a string literal
// (see build.mjs / build-web.mjs) and constant-folds this ternary, so each shell
// bundles only its own implementation — the other is dead-code-eliminated.
declare const __PLATFORM__: "extension" | "web";

export const platform: Platform = __PLATFORM__ === "web" ? webPlatform : extensionPlatform;
